import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SocialLinks } from './PortfolioComponents';

const BlogAuth = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [menuState, setMenuState] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuState(prevState => {
      if (!prevState) return 'active';
      return prevState === 'deactive' ? 'active' : 'deactive';
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (username === 'dsrk' && password === 'airtel') {
      sessionStorage.setItem('blogAuth', 'true');
      navigate('/blog/caffeine-chaos-cardano');
    } else {
      setError('Invalid credentials. Please try again.');
      setPassword('');
    }
  };

  return (
    <div style={{ background: 'linear-gradient(215deg, #f0f0f0 0%, #fafafa 100%)', minHeight: '100vh', position: 'relative' }}>
      {/* Menu overlay */}
      <div className={`menu-container ${menuState}`} style={menuState ? {} : { display: 'none' }}>
        <div className="overlay" />
        <div className="menu-items">
          <ul>
            <li><a href="/" onClick={toggleMenu}>HOME</a></li>
            <li><a href="/#about" onClick={toggleMenu}>ABOUT</a></li>
            <li><a href="/#projects" onClick={toggleMenu}>PORTFOLIO</a></li>
            <li><a href="/blog" onClick={toggleMenu}>BLOG</a></li>
            <li><a href="/archive/2024/uoh/soupbg" onClick={toggleMenu}>ARCHIVE</a></li>
          </ul>
          <SocialLinks />
        </div>
      </div>

      {/* Navigation */}
      <nav id="navbar" className="bg-active">
        <div className="nav-wrapper">
          <p className="brand">
            <a href="/" style={{ color: '#fafafa', textDecoration: 'none' }}>
              Dhanush <strong>SR Kenkiri</strong>
            </a>
          </p>
          <button
            onClick={toggleMenu}
            className={menuState === 'active' ? 'menu-button active' : 'menu-button'}
            aria-label="Toggle menu"
          >
            <span />
          </button>
        </div>
      </nav>

      {/* Auth Section */}
      <section id="blog-auth" style={{
        paddingTop: '8rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          maxWidth: '450px',
          width: '100%',
          padding: '0 2rem'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 20px 40px -20px rgba(37, 41, 52, 0.3)',
            padding: '3rem',
            border: '1px solid #f0f0f0'
          }}>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <i className="fas fa-lock" style={{ fontSize: '3rem', color: '#f300b4', marginBottom: '1rem', display: 'block' }}></i>
              <h2 style={{ fontSize: '2rem', color: '#252934', marginBottom: '0.5rem', fontWeight: '700' }}>Blog Access</h2>
              <p style={{ fontSize: '1.2rem', color: '#252934', margin: 0, fontWeight: '500' }}>Enter credentials to continue</p>
            </div>

            {error && (
              <div style={{
                background: '#fee',
                color: '#c33',
                padding: '1rem',
                borderRadius: '4px',
                fontSize: '1.2rem',
                marginBottom: '1.5rem',
                borderLeft: '4px solid #c33'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', fontSize: '1.2rem', fontWeight: '600', color: '#252934', marginBottom: '0.5rem' }}>
                  <i className="fas fa-user" style={{ marginRight: '0.5rem', color: '#f300b4' }}></i>
                  Username
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter username"
                  required
                  autoFocus
                  style={{
                    width: '100%',
                    padding: '1rem',
                    border: '1px solid #e0e0e0',
                    borderRadius: '4px',
                    fontSize: '1.4rem',
                    fontFamily: 'inherit',
                    color: '#252934'
                  }}
                />
              </div>

              <div style={{ marginBottom: '2rem' }}>
                <label style={{ display: 'block', fontSize: '1.2rem', fontWeight: '600', color: '#252934', marginBottom: '0.5rem' }}>
                  <i className="fas fa-key" style={{ marginRight: '0.5rem', color: '#f300b4' }}></i>
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                  style={{
                    width: '100%',
                    padding: '1rem',
                    border: '1px solid #e0e0e0',
                    borderRadius: '4px',
                    fontSize: '1.4rem',
                    fontFamily: 'inherit',
                    color: '#252934'
                  }}
                />
              </div>

              <button type="submit" style={{
                width: '100%',
                background: '#f300b4',
                color: '#fff',
                border: 'none',
                padding: '1rem',
                borderRadius: '4px',
                fontSize: '1.4rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 200ms'
              }}>
                <i className="fas fa-sign-in-alt" style={{ marginRight: '0.5rem' }}></i>
                Access Blog
              </button>
            </form>

            <div style={{
              marginTop: '1.5rem',
              paddingTop: '1.5rem',
              borderTop: '1px solid #e0e0e0',
              textAlign: 'center'
            }}>
              <p style={{ fontSize: '1.1rem', color: '#666', margin: 0 }}>Direct article links don't require login</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer - Compact Version */}
      <footer style={{ padding: '3rem 0 2rem' }}>
        <div className="wrapper" style={{ padding: '0 2rem' }}>
          <h3 style={{ fontSize: '1.4rem', marginBottom: '0.8rem' }}>THANKS FOR VISITING</h3>
          <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>© 2020 - {new Date().getFullYear()} Made with 🧡 - DSRK</p>
          <SocialLinks />
        </div>
      </footer>
    </div>
  );
};

export default BlogAuth;